// Copyright (c) 2021, DIALPAD INC., all rights reserved.

/**
 * Check to see if the DOM element is scrolled to the bottom.
 * @param {Object} element - DOM element
 */
export const isScrolledToBottom = (element) => {
    return element.scrollHeight - element.scrollTop === element.clientHeight;
};

export const getScrollbarWidth = (element) =>
    element.offsetWidth - element.clienWidth;

export const npsEnabled = () => process.env.NPS_ENABLED;
